import { EDealType } from '../../../utils/jsonQuery';

export const FILTER_TABS = {
  [EDealType.Sale]: 'Купить',
  [EDealType.RentLongterm]: 'Снять',
};
